__turbopack_context__.v({
  "container": "ContentTranslation-module__HcrbfG__container",
  "select": "ContentTranslation-module__HcrbfG__select",
});
